module.exports = __webpack_public_path__ + "static/media/chat13.f7581d40.gif";